// import './rxjs-extensions';

import { BrowserModule } from '@angular/platform-browser';
import { MaterializeModule } from 'angular2-materialize';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, XHRBackend, RequestOptions, BrowserXhr } from '@angular/http';
import { ToastyModule } from 'ng2-toasty';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { TextMaskModule } from 'angular2-text-mask';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CKEditorModule } from 'ng2-ckeditor';

import { RouterModule }   from '@angular/router';
import { AppRoutingModule }     from './app-routing.module';
//import { FileUploadModule } from 'ng2-file-upload';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BusyModule, BusyConfig} from 'angular2-busy';
import {NgxPaginationModule} from 'ngx-pagination';

import { AppComponent } from './app.component';
import { MenuComponent } from './shared/menu/menu.component';
import { HomeComponent } from './home/home.component';
import { DocumentosComponent } from './documentos/documentos.component';
import { CriarDocumentoComponent } from './documentos/criar.component';
import { EditarDocumentoComponent } from './documentos/editar.component';
import { ListaParticipantesComponent } from './lista-participantes/participantes.component';
import { VerListaParticipanteComponent } from './lista-participantes/participante.component';
import { ParticipantesComponent } from './participantes/participantes.component';

import { UsuariosComponent } from './usuarios/usuarios.component';

import { UploadParticipantesComponent } from './lista-participantes/upload.component';
import { LoginComponent } from './login/login.component';
import { EditarUsuarioComponent } from './usuarios/editar.component';

import { AuthAndACLService } from './auth_and_acl/authAndACL.service';
import { LogoutComponent } from './logout/logout.component';

import { httpFactory } from "./shared/http_intercept/http.factory";
import { Utils } from "./shared/utils";
import { ValidacaoComponent } from './validacao/validacao.component';
import { PreLoginComponent } from './pre-login/pre-login.component';
import { MeusDocumentosComponent } from './meus-documentos/meus-documentos.component';
import { UnidadesComponent } from './unidades/unidades.component';
import { CentrosComponent } from './centros/centros.component';
import { FormUnidadeComponent } from './unidades/form.component';
import { FormCentrosComponent } from './centros/form.component';
import { RelatoriosComponent } from './relatorios/relatorios.component';
import { LogsComponent } from './logs/logs.component';
import { CadastrarComponent } from './usuarios/cadastrar.component';
import { LoginAlunoComponent } from './login-aluno/login-aluno.component';
import { LembraSenhaComponent } from './usuarios/lembra-senha.component';
import { ResetarSenhaComponent } from './usuarios/resetar-senha.component';

import { FilterPipe } from './shared/filter.pipe';
import { GruposComponent } from './grupos/grupos.component';
import { FormGrupoComponent } from './grupos/form.grupo.component';
import { AdicionarUsuarioComponent } from './grupos/adicionar-usuario.component';
import { FormTiposCertificadosComponent } from './tipos_certificados/form.component';
import { TiposCertificadosComponent } from './tipos_certificados/tipos-certificados.component';
import { BoasVindasComponent } from './boas-vindas/boas-vindas.component';
import { EditarParticipanteComponent } from './participantes/editar-participante.component';
import { AssinaturasAssinadorComponent } from './assinaturas/assinaturas-assinador.component';
import { GovbrCallbackComponent } from './assinaturas/govbr-callback.component';
import { TransferirCertificadosComponent } from './participantes/transferir-certificados.component';
import { ValidarAssinaturaComponent } from './validar-assinatura/validar-assinatura.component';
import { ValidarAssinaturaUploadComponent } from './validar-assinatura-upload/validar-assinatura-upload.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    DocumentosComponent,
    CriarDocumentoComponent,
    EditarDocumentoComponent,
    ListaParticipantesComponent,
    UploadParticipantesComponent,
    ParticipantesComponent,
    LoginComponent,
    LogoutComponent,
    VerListaParticipanteComponent,
    UsuariosComponent,
    EditarUsuarioComponent,
    ValidacaoComponent,
    PreLoginComponent,
    MeusDocumentosComponent,
    UnidadesComponent,
    CentrosComponent,
    FormUnidadeComponent,
    FormCentrosComponent,
    RelatoriosComponent,
    LogsComponent,
    CadastrarComponent,
    LoginAlunoComponent,
    LembraSenhaComponent,
    ResetarSenhaComponent,
    FilterPipe,
    GruposComponent,
    FormGrupoComponent,
    AdicionarUsuarioComponent,
    FormTiposCertificadosComponent,
    TiposCertificadosComponent,
    BoasVindasComponent,
    EditarParticipanteComponent,
    AssinaturasAssinadorComponent,
    GovbrCallbackComponent,
    TransferirCertificadosComponent,
    ValidarAssinaturaComponent,
    ValidarAssinaturaUploadComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    FlashMessagesModule,
    //FileUploadModule,
    TextMaskModule,
    // InMemoryWebApiModule.forRoot(InMemoryDataService),
    AppRoutingModule,
    MaterializeModule,
    ToastyModule.forRoot(),
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BusyModule,
    NgxPaginationModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    CKEditorModule
  ],
  providers: [
    AuthAndACLService,
    Utils,
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions]
    }
  ],
  bootstrap: [AppComponent , LogoutComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts